// extracted by mini-css-extract-plugin
module.exports = {"addQuestionButton":"EditFormPanel_addQuestionButton__NQGcl","buttonContainer":"EditFormPanel_buttonContainer__1-Nor"};